import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalComponents from './global-components'
import utils from './utils'
import './libs'

// SASS Theme
import './assets/sass/app.scss'
import './assets/css/app.css'

import VueMobileDetection from 'vue-mobile-detection'
import { isTablet, isAndroid } from 'mobile-device-detect'

const app = createApp(App)
  .use(store)
  .use(router)
  .use(VueMobileDetection)
  .use(isTablet)
  .use(isAndroid)

globalComponents(app)
utils(app)

app.mount('#app')
